import { AccountMoveLineModel } from '../../accounting/types';
import { CommissionPlanType } from '../commission-plan-rule/types';
import { Filter } from '../../search/types';

export const commissionFeatureKey = 'commission';

export class CommissionModel {
  id: number;
  userId: number;
  contractId: number;
  amount: number;
  commissionPlanRuleId: number;
}

export type CommissionPreviewModel = {
  id: number;
  contractContactName: string;
  name: string;
  accountMoveType: string;
  parentId: number;
  subscriptionDate: string;
  accountMoveStatus: string;
  companyCommissionAmount: number;
  salesPersonCommissionRate: number;
  shareCommissionRate: number;
  salesPersonCommissionAmount: number;
  salesPersonName: string;
};

export type CommissionReportModel = {
  groupById: number;
  groupByName: string;
  healthAmount: number;
  carAmount: number;
  houseAmount: number;
  totalAmount: number;
};

export type SalesPersonCommissionModel = {
  id: number;
  accountMoveTypeId: number;
  contractName: string;
  debitAccountId: number;
  debitAccountName: string;
  creditAccountContactId: number;
  creditAccountContactName: string;
  creationDate: Date;
  accountMoveLines: AccountMoveLineModel[];
};

export type SalesPersonCommissionListModel = {
  salesPersonCommissions: SalesPersonCommissionModel[];
  filters: Filter[];
  isTotalCountSelected: boolean;
};

export type CommissionReportSalesPersonProductionDashboardAmountModel = {
  id: number;
  name: string;
  contractRequestAmount: number;
  waitingValidationAmount: number;
  openAmount: number;
  totalAmount: number;
};

export type CommissionReportSalesPersonProductionDashboardModel = {
  commissionReportSalesPersonProductionDashboardAmountModels: CommissionReportSalesPersonProductionDashboardAmountModel[];
  contractRequestFilter: Filter;
  waitingValidationFilter: Filter;
  openFilter: Filter;
};

export type CommissionReportSalesPersonCommissionsDashboardAmountModel = {
  id: number;
  name: string;
  companyAmount: number;
  salesPersonCommissionRate: number;
  salesPersonCommissionAmount: number;
};

export type CommissionReportSalesPersonCommissionsDashboardModel = {
  commissionReportSalesPersonCommissionsDashboardAmountModels: CommissionReportSalesPersonCommissionsDashboardAmountModel[];
  filters: Filter[];
};
